import React, { useState } from 'react';
import TuvaModal from '@tuva-ui/components/src/TuvaModal';
import ModalService from '../services/Modal.service';

const modalStyle = {
  top: '10px',
  width: '550px',
  padding: 0,
  transform: 'translateX(-50%)',
};

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function ForgotPasswordModal({ onCancel, onSwitchModal }) {
  const [email, setEmail] = useState('');
  const [formError, setFormError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  const isSubdomain =
    window.SUBDOMAIN !== undefined &&
    window.SUBDOMAIN !== '' &&
    window.SUBDOMAIN !== ' ' &&
    window.SUBDOMAIN !== null;

  function handleSubmit(e) {
    e.preventDefault();
    setFormSubmitted(true);
    setFormError('');

    if (!email.trim()) return;

    if (!validateEmail(email)) {
      setFormError('Please provide a valid email address.');
      return;
    }

    if (isSubmitting) return;
    setIsSubmitting(true);

    ModalService.forgotPassword(email).then(data => {
      if (data.error) {
        setFormError(data.message || 'Something went wrong.');
        setIsSubmitting(false);
      } else {
        setResponseMessage(data.message);
      }
    });
  }

  const emailError =
    formSubmitted && !email.trim() ? 'Enter Email address' : '';

  return (
    <TuvaModal isOpen onClose={onCancel} closeIcon style={modalStyle} className="tuva-common-modal">
      <div className="text-center text-gray-600 px-6">
        <h3 className="pt-4 pb-3 text-primary text-xl font-bold">
          Reset Password
        </h3>

        <div className="max-w-[374px] mx-auto">
          {!responseMessage && (
            <form className="w-full" onSubmit={handleSubmit} noValidate>
              <div className="mb-3 text-left">
                <label className="text-base flex justify-between">
                  <span className={emailError ? 'text-red-600' : ''}>
                    Email
                  </span>
                  {emailError && (
                    <span className="text-red-600 text-base">{emailError}</span>
                  )}
                </label>
                <input
                  className={`w-full mt-1 px-4 py-2.5 border rounded text-base outline-none focus:border-primary ${emailError ? 'border-red-500' : 'border-gray-400'}`}
                  type="text"
                  placeholder="name@example.com"
                  maxLength={254}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>

              {formError && (
                <div
                  className="text-red-600 text-base mt-2"
                  dangerouslySetInnerHTML={{ __html: formError }}
                />
              )}

              <input
                className="w-full mt-6 mb-6 py-3 px-10 bg-primary text-white font-bold rounded cursor-pointer hover:bg-primary-hover disabled:opacity-50 disabled:cursor-not-allowed"
                type="submit"
                value="Submit"
                disabled={isSubmitting}
              />
            </form>
          )}
        </div>

        {responseMessage && (
          <div className="my-3">
            <p className="text-base text-gray-600">{responseMessage}</p>
          </div>
        )}

        {!isSubdomain && (
          <p className="text-base mb-4">
            <span className="font-bold">Note to Students:</span> Please ask
            your teacher to reset your password.
          </p>
        )}
      </div>

      <div className="bg-accent-light py-3 text-center">
        <span className="text-gray-600 text-base">
          Already have an account?{' '}
        </span>
        <button
          type="button"
          className="text-base text-secondary-dark font-semibold hover:underline bg-transparent border-0 p-0 cursor-pointer"
          onClick={() => onSwitchModal('logIn')}
        >
          Sign In
        </button>
      </div>
    </TuvaModal>
  );
}

export default ForgotPasswordModal;
